import request from '@/utils/request';

// 结料明细
export function getMaterialDeliveryDetails(data) {
  return request({
    url: '/eos/materialDeliveryDetails/list',
    method: 'get',
    params: data,
  });
}
